import { generateKeyBetween } from "fractional-indexing";

/** 2つのキーの間に新しいキーを生成する（D&D 並び替え用） */
export const generateSortOrderBetween = (
  before: string | null,
  after: string | null,
): string => generateKeyBetween(before, after);
